import { FormProvider } from "react-hook-form";
import { useExtendedOrderForm } from "@/entities/new-order";
import { CreateOrderForm } from "@/widgets/create-order-form";
import BlockLoader from "@/Components/Loaders/BlockLoader";

export const ExtendOrder = () => {
  const { methods, handleReset, isLoading } = useExtendedOrderForm();

  return (
    <FormProvider {...methods}>
      <CreateOrderForm handleReset={handleReset} />
      {isLoading ? <BlockLoader size="lg" /> : null}
    </FormProvider>
  );
};
